import {
  AllPickersBindings,
  AllPickerStocks,
  PickerStockElement
} from 'types/typescript'
import {
  FlattenList,
  GetAllDurations,
  GetStockDuratons
} from './pricerDuration.types'

export const flattenList: FlattenList = list => list.reduce((flattenedList, duration) => (
  [...flattenedList, ...duration]
), [])

export const getAllDurations: GetAllDurations = (departureCity, pickersBindings) => (
  departureCity
    ? pickersBindings[departureCity.toLowerCase()]
      .reduce((acc: Writeable<AllPickersBindings>, duration) => {
        acc[duration.key] = duration
        return acc
      }, {})
    : (pickersBindings
        ? flattenList(Object.values(pickersBindings))
          .reduce((acc: Writeable<AllPickersBindings>, duration) => {
            if (!acc[duration.key] || acc[duration.key].price > duration.price) {
              acc[duration.key] = duration
            }
            return acc
          }, {})
        : {})
)

export const getStockDurations: GetStockDuratons = (departureCity, pickersBindingsStock) => {
  const allStockDurations = pickersBindingsStock?.reduce((acc: PickerStockElement[], bindingStock) => {
    if (!departureCity || bindingStock.key === departureCity) {
      acc.push(...bindingStock.pickers as PickerStockElement[])
    }
    return acc
  }, [])

  return allStockDurations?.reduce((acc: Writeable<AllPickerStocks>, durationStock) => {
    if (!acc[durationStock.key] || (acc[durationStock.key] && durationStock.isAvailable)) {
      acc[durationStock.key] = durationStock
    }
    return acc
  }, {})
}
